import { environment } from "environments/environment";

let encryption_key = environment.security.encryption_key;
let request_prefix = environment.security.request_prefix;

export async function encrypt(textToEncrypt: string): Promise<string> {
  const enc = new TextEncoder();
  const iv = crypto.getRandomValues(new Uint8Array(12));

  const keyMaterial = await window.crypto.subtle.importKey(
    "raw",
    enc.encode(encryption_key),
    { name: "PBKDF2" },
    false,
    ["deriveKey"]
  );

  const key = await window.crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: iv,
      iterations: 100000,
      hash: "SHA-256"
    },
    keyMaterial,
    { name: "AES-GCM", length: 256 },
    true,
    ["encrypt"]
  );

  const encrypted = await window.crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: iv
    },
    key,
    enc.encode(textToEncrypt)
  );

  const combined = new Uint8Array(iv.length + encrypted.byteLength);
  combined.set(iv, 0);
  combined.set(new Uint8Array(encrypted), iv.length);

  return btoa(String.fromCharCode(...combined));
}

export async function decryptRequest(base64Data: string): Promise<string> {
  const combined = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));

  const ivLength = 12;
  const tagLength = 16;

  const iv = combined.slice(0, ivLength);
  const ciphertextAndTag = combined.slice(ivLength);

  const ciphertext = ciphertextAndTag.slice(0, ciphertextAndTag.length - tagLength);
  const tag = ciphertextAndTag.slice(ciphertextAndTag.length - tagLength);

  const enc = new TextEncoder();

  const keyMaterial = await window.crypto.subtle.importKey(
    "raw",
    enc.encode(encryption_key),
    { name: "PBKDF2" },
    false,
    ["deriveKey"]
  );

  const key = await window.crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: iv,
      iterations: 100000,
      hash: "SHA-256"
    },
    keyMaterial,
    { name: "AES-GCM", length: 256 },
    false,
    ["decrypt"]
  );

  const encrypted = new Uint8Array(ciphertext.length + tag.length);
  encrypted.set(ciphertext, 0);
  encrypted.set(tag, ciphertext.length);

  const decrypted = await window.crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: iv
    },
    key,
    encrypted
  );

  return new TextDecoder().decode(decrypted);
}

export async function encryptRequestWithPrefix(request: string){
    const decryptedPrefix = atob(request_prefix);
    const concatenatedRequest = `${decryptedPrefix}${request}`;
    const encrypted = await encrypt(concatenatedRequest);
    return encrypted;
}

